import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

import Maska from 'maska'
import axios from 'axios'

const debug = process.env.NODE_ENV !== 'production'

const API_URL = debug
    ? process.env.VUE_APP_API_URL_DEVELOPMENT
    : process.env.VUE_APP_API_URL_PRODUCTION

export const TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY

const token = localStorage.getItem(TOKEN_KEY) || null

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(Maska);

router.isReady().then(() => {
  app.mount('#app');
});
